import {
  Dispatch,
  ReactNode,
  SetStateAction,
  createContext,
  useState,
} from 'react';

interface Props {
  children: ReactNode;
}

interface PageContextInterface {
  tabIndex: number;
  setTitle: Dispatch<SetStateAction<string>>;
  setTabIndex: Dispatch<SetStateAction<number>>;
  title: string;
}

export const PageContext = createContext<PageContextInterface>({
  tabIndex: 0,
  setTitle: () => {},
  setTabIndex: () => {},
  title: '',
});

const PageContextProvider = ({ children }: Props) => {
  const [title, setTitle] = useState('');
  const [tabIndex, setTabIndex] = useState(0);

  return (
    <PageContext.Provider value={{ title, setTitle, tabIndex, setTabIndex }}>
      {children}
    </PageContext.Provider>
  );
};

export default PageContextProvider;
